// import AsyncStorage from '@react-native-async-storage/async-storage';
// import {
// 	PERSIST_ZUSTAND_STORE_KEY,
// 	StoreKeys,
// } from '@gov-nx/store';
import { useEffect } from 'react';
import {
	GovFlex,
	GovLayout,
	GovLayoutColumn,
} from '@gov-design-system-ce/react';
import { useEnvironment } from '@gov-nx/core/hooks';
import { Button, ContentLayout } from '@gov-nx/ui/web';

interface ErrorPageProps {
	message: string;
}

export const ErrorPage = ({ message }: ErrorPageProps) => {
	const env = useEnvironment();

	useEffect(() => {
		if (!env.isLocalhost) {
			// Todo: Remove storage for web
			// (Object.keys(StoreKeys) as Array<keyof typeof StoreKeys>).map(
			// 	async (key) => {
			// 		await AsyncStorage.removeItem(
			// 			PERSIST_ZUSTAND_STORE_KEY + ':' + StoreKeys[key]
			// 		);
			// 	}
			// );
		}
	}, [env]);

	return (
		<main>
			<GovLayout type="text">
				<GovLayoutColumn className="min-h-screen mt-0! md:mt-20!">
					<ContentLayout>
						<GovFlex
							gap="m"
							alignItems="center"
							direction="column"
							responsive="false"
							className="gov-block text-center mt-0! px-(--spacing-m)! sm:px-(--spacing-l)!">
							<GovFlex
								justifyContent="center"
								alignItems="center"
								responsive="false"
								className="gov-icon w-[96px]! h-[96px]! mb-1! rounded-full text-(--background-primary) bg-linear-to-b from-(--background-primary-subtle) to-(--background-block-primary) [ sm:mb-4! ]">
								<svg
									className="w-[48px]! h-[48px]!"
									width="48"
									height="48"
									viewBox="0 0 48 48"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M13.3935 24L24.0001 34.6066L21.5252 37.0815C19.7678 38.8388 16.9186 38.8388 15.1612 37.0815L10.9186 32.8388C9.16125 31.0815 9.16125 28.2322 10.9186 26.4749L13.3935 24Z"
										fill="#F3F7FC"
									/>
									<path
										d="M24 13.3936L34.6066 24.0002L37.0815 21.5253C38.8388 19.7679 38.8388 16.9187 37.0815 15.1613L32.8388 10.9187C31.0815 9.16132 28.2322 9.16132 26.4749 10.9187L24 13.3936Z"
										fill="#F3F7FC"
									/>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M36.9054 36.551L33.3698 33.0155L34.4305 31.9548L37.966 35.4904L36.9054 36.551Z"
										fill="#2362A2"
									/>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M42.4108 27.932H37.4108V26.432H42.4108V27.932Z"
										fill="#2362A2"
									/>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M26.4332 37.4103V42.4103H27.9332V37.4103H26.4332Z"
										fill="#2362A2"
									/>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M20.0692 5.59047V10.5905H21.5692V5.59047H20.0692Z"
										fill="#2362A2"
									/>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M10.591 21.5681H5.59096V20.0681H10.591V21.5681Z"
										fill="#2362A2"
									/>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M14.9851 14.6307L11.4495 11.0952L12.5102 10.0345L16.0457 13.57L14.9851 14.6307Z"
										fill="#2362A2"
									/>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M20.9961 22.4089L19.9354 21.3482L16.3997 24.8839L13.3944 21.8786L9.85888 25.4141C7.51574 27.7573 7.51574 31.5563 9.85888 33.8994L11.45 35.4905L2.96484 43.9756L4.0255 45.0363L12.5106 36.5512L14.1015 38.1421C16.4447 40.4852 20.2437 40.4852 22.5868 38.1421L26.1223 34.6065L23.1172 31.6014L26.6526 28.066L25.592 27.0054L22.0566 30.5408L17.4604 25.9446L20.9961 22.4089ZM24.0011 34.6064L13.3945 23.9998L10.9196 26.4747C9.16227 28.2321 9.16227 31.0813 10.9196 32.8387L15.1623 37.0813C16.9196 38.8387 19.7689 38.8387 21.5262 37.0813L24.0011 34.6064Z"
										fill="#2362A2"
									/>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M45.037 4.02415L36.5519 12.5092L38.1428 14.1001C40.4859 16.4432 40.4859 20.2422 38.1428 22.5854L34.6073 26.1209L21.8793 13.393L25.4149 9.85746C27.758 7.51431 31.557 7.51431 33.9002 9.85746L35.4911 11.4484L43.9762 2.96338L45.037 4.02415ZM34.6068 23.9998L24.0002 13.3932L26.4751 10.9183C28.2324 9.16093 31.0817 9.16093 32.839 10.9183L37.0817 15.1609C38.839 16.9183 38.839 19.7675 37.0817 21.5249L34.6068 23.9998Z"
										fill="#2362A2"
									/>
								</svg>
							</GovFlex>
							<GovFlex
								gap="s"
								direction="column">
								<h1 className="text-headline-m! text-(--text-primary)">
									Nastala chyba
								</h1>
								<p className="text-body-l! text-(--text-secondary)">
									Na opravě usilovně pracujeme, vraťte se, prosím, za chvíli.
								</p>
							</GovFlex>
							<br />
							<GovFlex
								gap="s"
								direction="column">
								<h1 className="text-headline-m! text-(--text-primary)">
									Something went wrong
								</h1>
								<p className="text-body-l! text-(--text-secondary)">
									We&apos;re working hard on the repair, please come back in a
									moment.
								</p>
								<p className="hidden">{message}</p>
							</GovFlex>
							<Button
								onClick={() => window.location.reload()}
								color="primary"
								size="l"
								type="solid"
								className="mt-1! [ sm:mt-2! ]">
								Aktualizovat stránku/Refresh page
							</Button>
						</GovFlex>
					</ContentLayout>
				</GovLayoutColumn>
			</GovLayout>
		</main>
	);
};
